<style lang='less' scoped>
@import '../base.less';
</style>
<template>
  <div>
    <!-- SEARCH -->
    <Row>
      <Col span="24">
        <Card class="margin-bottom-10">
          <Form inline>
            <FormItem class='margin-bottom-0'>
              <Input clearable v-model='searchConf.ip' :placeholder="$t('请输入IP地址') "></Input>
            </FormItem>
            <FormItem class="margin-bottom-0">
              <Button type="primary" @click="search">{{ $t('find_button') }}</Button>
            </FormItem>
          </Form>
        </Card>
      </Col>
    </Row>        <!--    -->
    <Row>
      <Col span='24'>
        <Card>
          <!-- ADDBUTTON -->
          <div class='margin-bottom-15'>
            <Button type='primary' v-has="'userManage/userIpBlack/add'" @click='preAdd' icon='md-add'>
              {{ $t('add_button') }}
            </Button>
          </div>
          <!-- DATA -->
          <div>
            <Table :loading='listLoading' :columns='columnsList' :data='tableData' border></Table>
          </div>
          <!-- PAGE -->
          <div class='margin-top-15' style='text-align: center'>
            <Page :total='tableShow.listCount' :current='tableShow.currentPage' :page-size='tableShow.pageSize'
                  @on-change='changePage' @on-page-size-change='changeSize'
                  :page-size-opts='[10,20,30,40,50,100,200,300]' show-elevator show-sizer show-total></Page>
          </div>
        </Card>
      </Col>
    </Row>
    <!-- windowAddEdit -->
    <Modal v-model="windowadd.show" width="668" :styles="{top: '30px'}" @on-visible-change="windowaddCancel">
      <p slot="header" style="color:#2d8cf0">
        <Icon type="md-alert"></Icon>
        <span>{{ windowaddItem.id ? '编辑' : '新增' }}</span>
      </p>
      <Form ref="windowaddForm" :rules="windowaddValidate" :model="windowaddItem" :label-width="80">
        <FormItem label='禁用IP' prop='ip'>
          <Input v-model='windowaddItem.ip' placeholder='请输入禁用IP'></Input>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" @click="windowaddCancel()" class="margin-right-10">取消</Button>
        <Button type="primary" @click="windowaddSubmit" :loading="windowadd.loading">确定</Button>
      </div>
    </Modal>
    <!--    -->
  </div>
</template>
<script>
import {
  getList,
  add,
  del,
} from '@/api/userManage/userIpBlack'
import {
  formattingMonth,
  lastMonthDate
} from '@/libs/time'

export default {
  name: 'interface_list',
  data () {
    return {
      timeOptions: {
        shortcuts: [{
          text: '今天',
          value () {
            let a = new Date(new Date(new Date().toLocaleDateString()).getTime())
            let b = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)
            return [a, b]
          }
        },
          {
            text: '昨天',
            value () {
              let a = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000)
              let b = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000 + 24 * 60 *
                  60 * 1000 - 1)
              return [a, b]
            }
          },
          {
            text: '一周',
            value () {
              let a = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000 * 7)
              let b = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)
              return [a, b]
            }
          },
          {
            text: '本月',
            value () {
              return formattingMonth()
            }
          },
          {
            text: '上月',
            value () {
              return lastMonthDate()
            }
          },
        ]
      },
      columnsList: [{
        title: this.$t('IP'),
        key: 'ip',

        minWidth: 120,
        align: 'center'
      }, {
        title: this.$t('加入时间'),
        key: 'add_time',
        minWidth: 120,
        align: 'center'
      }, {
        title: this.$t('添加人'),
        key: 'admin_name',
        minWidth: 120,
        align: 'center'
      }, {
        title: this.$t('操作'),
        align: 'center',
        minWidth: 120,
        render: (h, params) => {
          let vm = this
          return h('div', [h('Poptip', {
            props: {
              confirm: true,
              title: this.$t('您确定要删除这条数据吗?'),
              transfer: true
            },
            on: {
              'on-ok': () => {
                console.log(params)
                del(params.row.id).then(response => {
                  this.$Message.success(response.data.msg)
                  this.getList()
                })
                params.loading = false
              }
            }
          }, [
            h('Button', {
              style: {
                margin: '0 5px'
              },
              props: {
                type: this.$t('error'),
                placement: 'top',
                loading: params.isDeleting,
                disabled: !vm.buttonShow.del
              }
            }, this.$t('删除'))
          ])])
        }
      },],
      tableData: [],//用于放LIST数据绑定
      tableShow: { //用于分页
        currentPage: 1,
        pageSize: 10,
        listCount: 0
      },
      searchConf: { searchTime: [], }, // 搜索字段

      buttonShow: { //按钮状态显示
        edit: true,
        del: true,
        changeStatus: true
      },
      listLoading: false, //显示加载中状态
      //弹窗--------------
      windowadd: { //弹窗
        show: false,
        loading: false,
        index: 0
      },
      windowaddItem: { //弹窗数据绑定
        id: 0
      },
      windowaddValidate: {//窗口校验规则
      },
      //----------------
    }
  },
  created () {
    let vm = this
    vm.getList()
    vm.hasRule('userManage/userIpBlack/edit').then(res => {
      vm.buttonShow.edit = res
    })
    vm.hasRule('userManage/userIpBlack/del').then(res => {
      vm.buttonShow.del = res
    })
    vm.hasRule('userManage/userIpBlack/changeStatus').then(res => {
      vm.buttonShow.changeStatus = res
    })
  },
  methods: {
    preAdd () {
      let vm = this
      vm.windowadd.show = true
    },
    changePage (page) {
      this.tableShow.currentPage = page
      this.getList()
    },
    changeSize (size) {
      this.tableShow.pageSize = size
      this.getList()
    },
    search () {
      this.tableShow.currentPage = 1
      this.getList()
    },
    getList () {
      let vm = this
      vm.listLoading = true
      getList({
        page: vm.tableShow.currentPage,
        size: vm.tableShow.pageSize,
        search: vm.searchConf
      }).then(response => {
        vm.tableData = response.data.data.list
        vm.tableShow.listCount = response.data.data.count
        vm.listLoading = false
      })
    },

    timeChange (datetimerange) { //时间修改，自动计算尾部时间
      if (datetimerange[0] !== '' && datetimerange[1] !== '') {
        let patt = /00:00:00/
        this.searchConf.searchTime = [datetimerange[0], datetimerange[1]]
        if (patt.test(datetimerange[1])) {
          datetimerange[1] = datetimerange[1].replace('00:00:00', '23:59:59')
          this.searchConf.searchTime = [datetimerange[0], datetimerange[1]]
        }
      } else {
        this.searchConf.searchTime = []
      }
    },
    sortChange: function ({ column, key, order }) {
      //order值可能为asc,desc,normal
      this.searchConf.order = [key, order]
      if (order == 'normal') {
        this.searchConf.order = []
      }
      this.getList()
    },
    windowaddCancel (data) {
      if (!data) {
        this.windowaddItem.id = 0
        this.$refs['windowaddForm'].resetFields()
        this.windowadd.show = false
        this.windowadd.loading = false
        this.windowadd.index = 0
      }
    }, windowaddSubmit () {
      let vm = this
      vm.$refs['windowaddForm'].validate((valid) => {
        if (valid) {
          vm.windowadd.loading = true
          if (vm.windowaddItem.id === 0) {
            add(vm.windowaddItem).then(response => {
              vm.$Message.success(response.data.msg)
              vm.getList()
              vm.windowaddCancel()
            }).catch(() => {
              vm.windowadd.loading = false
            })
          } else {
            edit(vm.windowaddItem).then(response => {
              vm.$Message.success(response.data.msg)
              vm.getList()
              vm.windowaddCancel()
            }).catch(() => {
              vm.windowadd.loading = false
            })
          }
        }
      })
    },
  }
}
</script>
